import { Drinker } from '@/pages/Quote/components/Drinker';
import { convertCentsToDollars } from '@thdinc/hpf-shared';
import { sub } from 'date-fns';

export enum ProductType {
	// Cocktails
	Aperol = 'aperol',
	BeerCocktail = 'beer_cocktail',
	Cognac = 'cognac',
	Gin = 'gin',
	Liqueur = 'liqueur',
	Mezcal = 'mezcal',
	Rum = 'rum',
	RumDark = 'rum_dark',
	Pisco = 'pisco',
	Prosecco = 'prosecco',
	Sparkling = 'sparkling',
	SparklingWine = 'sparkling_wine',
	SparklingRose = 'sparkling_rose',
	Tequila = 'tequila',
	Vermouth = 'vermouth',
	Vodka = 'vodka',
	Whisky = 'whisky',
	// Additional
	Beer = 'beer',
	RedWine = 'red_wine',
	Seltzer = 'seltzer',
	Water = 'water',
	WhiteWine = 'white_wine',
}

export function getCocktailProducts(ingredients: any[], numberOfCocktails: number) {
	return ingredients.reduce((acc, ingredient) => {
		if (!ingredient.product) return acc;
		const productData = getCocktailProduct(ingredient as any, numberOfCocktails);
		acc.push({
			...productData,
			ingredientId: ingredient.id,
		});
		return acc;
	}, []);
}
export function getCocktailProduct(
	ingredient: any,
	numberOfCocktails: number,
	cocktailId?: string,
) {
	console.log('numberOfCocktails------------:', numberOfCocktails);
	console.log('cocktailId------------:', cocktailId);
	console.log('ingredient------------:', ingredient);

	const product = cocktailId === 'custom' ? ingredient : ingredient?.product;
	const sizeMl = product?.size != null ? Number(product.size) : 0;
	//add 1.5 oz for custom cocktails
	const qtyOz =
		cocktailId === 'custom' ? 150 : ingredient?.qty_oz != null ? Number(ingredient.qty_oz) : 0;
	if (!sizeMl || !Number.isFinite(qtyOz) || !Number.isFinite(numberOfCocktails)) {
		return { quantity: 1 };
	}
	const totalIngredientQty = qtyOz * 30 * numberOfCocktails;
	const totalProductQty = Math.ceil(totalIngredientQty / (sizeMl * 100));
	return {
		productId: product?.id,
		cocktailId: ingredient?.cocktail_id,
		quantity: Math.max(1, totalProductQty),
        size: sizeMl,
	};
}
export const cocktailQuantity = (it: any): number => {
	const lineType = it?.type?.type; // "cocktails" | "products"
	if (lineType === 'cocktails') {
		const cocktail = it?.cocktails;
		// Custom cocktail: use the user-entered qty
		if (cocktail?.id === 'custom' || cocktail?.value === 'custom') {
			return Number(it?.qty) || 0;
		}
		// Sum ingredient product quantities
		const ingredients = Array.isArray(cocktail?.cocktail_ingredients)
			? cocktail.cocktail_ingredients
			: [];
		const total = ingredients.reduce((sum: number, ing: any) => {
			return sum + (Number(ing?.product?.quantity) || 0);
		}, 0);
		return total;
	}
	if (lineType === 'products') {
		const q = it?.quantity ?? it?.qty;
		// const q = it?.brand?.quantity ?? it?.quantity ?? it?.qty;
		return Number(q) || 0;
	}
	return 0;
};

export function getCocktailPricePerItemCents(it: any): number {
	const lineType = it?.type?.type;
	const cocktail = it?.cocktails;
	if (it?.provider?.value === 'customer-provide' || it?.provider?.value === 'ho-provide') return 0;
	let base = 0;
	if (cocktail?.id === 'custom' || cocktail?.value === 'custom') {
		base = Number(it?.brand?.price) || 0;
	} else {
		base =
			lineType === 'products'
				? Number(it?.brand?.price) || 0
				: Number(it?.brand?.product?.price) || 0;
	}
	return Math.round(base);
}

export const cocktailPrice = (it: any): string => {
	const lineType = it?.type?.type; // "cocktails" | "products"
	const cocktail = it?.cocktails;
	if (it?.provider?.value === 'customer-provide' || it?.provider?.value === 'ho-provide') {
		return convertCentsToDollars('0');
	}
	const qty = Number(it?.qty) || 0;
	const perItemCents = getCocktailPricePerItemCents(it);
	return convertCentsToDollars(String(perItemCents * qty));
	// return convertCentsToDollars(String(it?.brand?.price * cocktailQuantity(it)));
	// if (lineType === "cocktails") {
	//     const cocktail = it?.cocktails;
	//     if (cocktail?.id === "custom" || cocktail?.value === "custom") {
	//         return convertCentsToDollars(String(it?.brand?.price * cocktailQuantity(it)));
	//     }
	//     //cocktail ingredients with products
	//     const ingredients = Array.isArray(cocktail?.cocktail_ingredients)
	//         ? cocktail.cocktail_ingredients
	//         : [];
	//     const totalCents = ingredients.reduce((sum: number, ing: any) => {
	//         return sum + (Number(ing?.product?.price) || 0);
	//     }, 0);
	//     return convertCentsToDollars(String(totalCents));
	// }
	// if (lineType === "products") {
	//     return convertCentsToDollars(String(it?.brand?.price * cocktailQuantity(it)));
	// }
	// return convertCentsToDollars('0');
};
export function getProductQuantity(
	product: any,
	productType: any,
	guests: number,
	cocktailCount: number,
	numberOfCocktails: number,
) {
	const safeGuests = Number.isFinite(guests) ? guests : 0;
	const safeCocktails = Number.isFinite(numberOfCocktails) ? numberOfCocktails : 0;
	const safeCocktailCount = cocktailCount > 0 ? cocktailCount : 1;

	console.log('product------------:', product);
	console.log('productType------------:', productType);
	console.log('safeCocktails------------:', safeCocktails);
	console.log('safeCocktailCount------------:', safeCocktailCount);
	console.log('safeGuests------------:', safeGuests);

	switch (productType) {
		case ProductType.Beer:
		case ProductType.Seltzer:
			return Math.ceil(safeCocktails / product?.quantity / safeCocktailCount);
		// case ProductType.Sparkling:
		case ProductType.SparklingWine:
		case ProductType.RedWine:
		case ProductType.WhiteWine: {
			const totalIngredientQty = 5 * 30 * safeCocktails;
			const totalProductQty = Math.ceil(
				totalIngredientQty / product?.size / safeCocktailCount,
			);
			return totalProductQty;
		}
		// return Math.ceil(Math.ceil((safeCocktails * 0.1) / 5) / safeCocktailCount); // before 0.15
		case ProductType.Water:
			return Math.ceil((((safeGuests * 1.5) / 10) * 10) / product?.quantity);
		default:
			return Math.ceil(safeCocktails * 0.1);
	}
}
/** Product type sets for 10% wines / 10% beers split within the 20% product share (when cocktails + products). sparkling_wine is separate (5%). */
const WINE_PRODUCT_TYPES = new Set([
	'red_wine',
	'white_wine',
	'sparkling_rose',
	'sparkling',
	'prosecco',
]);
const BEER_PRODUCT_TYPES = new Set(['beer', 'seltzer', 'beer_cocktail']);

export function isWineProduct(value: string | undefined): boolean {
	return value != null && WINE_PRODUCT_TYPES.has(value);
}
export function isBeerProduct(value: string | undefined): boolean {
	return value != null && BEER_PRODUCT_TYPES.has(value);
}
/** Sparkling wine has its own 5% allocation, separate from the 100% (80% cocktails + 20% wines/beers). */
export function isSparklingWineProduct(value: string | undefined): boolean {
	return value === 'sparkling_wine';
}
/** Water is 1.5 per guest, not part of the percentage allocation. */
export function isWaterProduct(value: string | undefined): boolean {
	return value === 'water';
}

export function getProductType(productType: any) {
	switch (productType) {
		case ProductType.Beer:
		case ProductType.Seltzer:
			return 'cases';
		case ProductType.Sparkling:
		case ProductType.SparklingWine:
		case ProductType.RedWine:
		case ProductType.WhiteWine:
			return 'bottles'; // before 0.15
		case ProductType.Water:
			return 'cases';
		default:
			return 'bottles';
	}
}
export function calculateDiscountedTotal(subTotal: number, discount: any) {
	if (!discount?.enabled) return subTotal;
	const amount = Number(discount.amount) || 0;
	const percentage = Number(discount.percentage) || 0;
	// if amount > 0, subtract amount
	if (amount > 0) return Math.max(0, subTotal - amount);
	// if percentage > 0, subtract percentage of subtotal
	if (percentage > 0) return Math.max(0, subTotal - (subTotal * percentage) / 100);
	// otherwise no discount
	return subTotal;
}

export function calculatePlatformFee(subTotal: number, platformFeeRate: number) {
	if (platformFeeRate > 0 && subTotal > 0) {
		return (subTotal * platformFeeRate) / 100;
	} else {
		return 0;
	}
}
export function calculatePackagePlatformFee(subTotal: number, platformFeeRate: number) {
	if (platformFeeRate > 0 && subTotal > 0) {
		const fee = subTotal / platformFeeRate;
		return subTotal - fee;
	} else {
		return 0;
	}
}

export const fmt = (n: number) =>
	n?.toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });

export const nnum = (v: unknown): number => {
	const n = typeof v === 'string' && v.trim() === '' ? NaN : Number(v);
	return Number.isFinite(n) ? n : 0;
};

export const calculateEstimatedDrinks =(guests:number, drinkerType: Drinker, eventLengthHours: number) =>{
    if (drinkerType === 'heavy') {
        return Number(eventLengthHours) * 2 * guests;
    } else if (drinkerType === 'medium') {
        return (Number(eventLengthHours) + 1) * guests;
    } else if (drinkerType === 'light') {
        return Number(eventLengthHours) * guests;
    }
      return (Number(eventLengthHours) + 1) * guests;
};